<template>
    <div>
        <div class="text-center">
            <h3 class="mt-0">Politique de confidentialité</h3>
            <p class="m-0">Activix Inc. ▪ Version 12.01</p>
            <p class="m-0">Date d'entrée en vigueur : 1er Décembre 2017</p>
        </div>
        <div class="text-justify">
            <h4>1. Préambule</h4>
            <p>
                La présente Politique de confidentialité (ci-après la «
                <strong>Politique</strong> ») est un contrat vous (signifiant l’utilisateur des
                produits Activix ou le client d’Activix Inc.) liant à nous (signifiant Activix Inc.
                ou tout membre ou personnel d’Activix Inc.) et représentant l’accord de volonté
                afférent à la collecte, à l’utilisation et à la communication de vos renseignements
                personnels.
            </p>
            <p>
                IL EST PRIMORDIAL QUE VOUS LISIEZ ET QUE VOUS CONSENTIEZ PLEINEMENT À LA POLITIQUE
                AVANT DE CONSULTER NOTRE SITE WEB, AVANT DE COMMUNIQUER AVEC NOUS OU AVANT DE VOUS
                CRÉER UN PROFIL.
            </p>
            <p>
                En interagissant avec nous, vous acceptez et consentez à ce que la collecte,
                l’utilisation et la communication de vos renseignements personnels soient régies par
                la présente Politique. Les interactions visées par la Politique incluent notamment
                la consultation et l’utilisation de nos produits web ou via applications mobiles
                (ci-après « Produits ») portant le même nom ou un nom différent, tel que NioText,
                vos communications avec nous et/ou tout autre utilisateur, de même que le paiement
                pour les services que nous offrons.
            </p>
            <p>
                À DÉFAUT DE NE PAS CONSENTIR OU DE NE PAS COMPRENDRE PLEINEMENT NOTRE POLITIQUE,
                VEUILLEZ CESSER D’UTILISER LES PRODUITS ET COMMUNIQUEZ DIRECTEMENT AVEC NOTRE AGENT
                RESPONSABLE DE LA PROTECTION DES RENSEIGNEMENTS PERSONNELS AU MOYEN DES COORDONNÉES
                FIGURANT AU BAS DE CETTE PAGE.
            </p>
            <p>Le présent préambule fait partie intégrante de la présente Politique.</p>

            <h4>2. Consentement</h4>
            <p>
                En nous fournissant votre information personnelle, vous nous autorisez à l’utiliser
                et à la communiquer dans le cadre de nos prestations de services, pour faciliter les
                relations auprès d’Activix, ses clients et des utilisateurs des Produits et qu’elle
                soit accessible lorsque nécessaire, à des employés, partenaires ou mandataires
                d’Activix, dans l’exercice de leurs fonctions et à des fins directement liées à
                l’utilisation, mise à jour ou maintenance des Produits, cela conformément à la
                présente Politique et tel qu'autorisé ou requis par la loi, ainsi qu’implicitement
                si indiqué par les circonstances. De plus, vous autorisez les clients de nos
                Produits à enregistrer vos clients téléphoniques avec ceux-ci pour des fins de
                formation.
            </p>
            <p>
                Activix sollicitera votre autorisation avant d'utiliser vos renseignements
                personnels à des fins autres que celles visées par votre consentement initial.
            </p>
            <p>
                Vous pouvez retirer votre consentement à tout moment, sous réserve de restrictions
                juridiques et contractuelles et d'un préavis raisonnable. Si vous nous fournissez
                des renseignements personnels concernant un autre particulier, vous vous engagez à
                détenir l’autorisation nécessaire pour le faire et/ou que les utilisateurs ont
                obtenu tous les consentements nécessaires de la part de ce particulier afin de nous
                permettre de recueillir, d'utiliser et de communiquer ces renseignements personnels
                aux fins établies dans la présente Politique.
            </p>
            <p>
                Vous pouvez retirer votre consentement ou demander à ne plus recevoir de
                communication électronique de notre part en écrivant à info@activix.ca.
            </p>

            <h4>3. Quels renseignements personnels recueillons-nous ?</h4>
            <p>
                En plus des renseignements personnels que nous recueillons au moment de votre
                inscription (ex. votre nom, prénom, adresse, numéro de téléphone et adresse
                courriel) ainsi que toute autre information requise lors de votre navigation sur nos
                Produits (ex. vos données de géolocalisation, renseignements liés au paiement,
                etc.), nous conservons l’historique de vos interactions avec les Produits, dont vos
                avis, communications et publications sur les Produits.
            </p>
            <p>
                Par ailleurs, nous utilisons l’outil d'analyse d’audience Google Analytics (ci-après
                «
                <strong>Google</strong> ») afin d’obtenir certaines informations relatives aux
                utilisateurs de nos Produits. Les informations qui nous sont communiquées par Google
                sont non identifiables et visent notamment à nous informer sur des données
                démographiques et géographiques de nos utilisateurs (ex. âge, sexe, langue,
                territoire, etc.) ainsi que leur comportement sur nos Produits, de même que leurs
                affinités (ex. style de vie) et finalement nous informe aussi sur la technologie
                utilisée par ceux-ci afin d’accéder à nos Produits (ex. navigateur, système
                d’exploitation, appareils utilisés, adresse IP, etc.).
            </p>

            <h4>
                4. Quelles technologies utilisons-nous pour recueillir vos renseignements personnels
                ?
            </h4>
            <p>
                Lorsque vous utilisez nos Produits, nous conservons l’historique de vos interactions
                sur notre serveur.
            </p>
            <p>
                Quant aux renseignements recueillis par notre outil d'analyse d’audience, Google
                procède notamment par l’inscription d’un numéro dans votre navigateur à l'aide d'un
                <a href="https://support.google.com/adwords/answer/2407785?hl=fr">fichier témoin</a>
                afin de mémoriser votre visite. Cela permet ensuite à Google d’associer votre
                navigateur à une catégorie démographique à laquelle vous semblez appartenir en
                fonction des autres sites que vous visitez. Google utilise également votre adresse
                IP afin d’identifier le pays, la région et la ville dans lesquels votre ordinateur
                se connecte à Internet pour accéder à nos Produits. Pour de plus amples informations
                sur la collecte de vos renseignements personnels, nous vous invitions à consulter la
                page de Google concernant la
                <a href="https://support.google.com/analytics/topic/2919631?hl=fr"
                    >Sécurité et confidentialité des données.</a
                >
            </p>

            <h4>5. À quelles fins utilisons-nous vos renseignements personnels ?</h4>
            <p>
                Nous utilisons notamment vos renseignements personnels pour satisfaire les objectifs
                suivants :
            </p>
            <ul>
                <li>
                    Obtenir des renseignements sur l'utilisation des Produits afin d'augmenter et
                    améliorer l'expérience des utilisateurs ;
                </li>
                <li>Vous offrir les Produits pour vos opérations commerciales ;</li>
                <li>Collecter des statistiques pour diffusion ultérieure ;</li>
                <li>
                    Envoyer des courriels aux utilisateurs des Produits et répondre aux demandes
                    formulées par ces utilisateurs ;
                </li>
                <li>
                    Renseigner les utilisateurs sur le fonctionnement, les nouveautés ainsi que les
                    services offerts par Activix, tels que des mises à jour, notre bulletin
                    électronique, des modifications aux Conditions d'utilisation ou à la Politique ;
                </li>
                <li>
                    Effectuer toute autre action nécessaire pour protéger la sécurité ou pour
                    assurer le bon fonctionnement des Produits.
                </li>
            </ul>
            <p>
                Sauf indication contraire, vous devez supposer que toute information que vous
                fournissez sur les Produits peut être utilisée pour des fins de sollicitation
                générale ou à des fins commerciales et que ces informations peuvent également être
                partagées avec nos partenaires, sociétés affiliées, clients ou fournisseurs avec qui
                nous entretenons des relations d’affaires.
            </p>

            <h4>6. De quelle façon protégeons-nous vos renseignements personnels ?</h4>
            <p>
                L’entièreté de nos mesures de sécurité ne peut être divulguée pour des raisons
                évidentes. Nous pouvons toutefois vous informer que vos renseignements personnels
                sont conservés dans nos serveurs et le contenu y est protégé par mots de passe
                cryptés qui sont régulièrement mis à jour.
            </p>
            <p>
                Malgré les mesures de sécurité mises place afin de protéger vos renseignements
                personnels, aucune mesure n’est infaillible.
            </p>
            <p>
                Nous nous engageons à ne donner accès aux données des Produits et à leur contenu
                qu’à nos employés, collaborateurs, sous-traitants, dirigeants et administrateurs
                ayant un besoin d’y avoir accès aux fins de rendre des services en lien avec les
                Produits, et ceux-ci seront tenus d’en respecter la confidentialité.
            </p>
            <p>
                EN NAVIGUANT ET EN UTILISANT LES SERVICES OFFERTS SUR NOS PRODUITS, VOUS ACCEPTEZ ET
                COMPRENEZ LES RISQUES QUE VOS RENSEIGNEMENTS PERSONNELS PUISSENT ÊTRE ILLÉGALEMENT
                OBTENUS PAR DES TIERS ET/OU LOGICIELS MALVEILLANTS. CONSÉQUEMMENT, VOUS RENONCEZ À
                TOUT RECOURS ET/OU RÉCLAMATION ENVERS ACTIVIX INC., SES FILIALES, SOCIÉTÉS
                ASSOCIÉES, ADMINISTRATEURS OU ACTIONNAIRES EN CAS DE VOL OU UTILISATION MALVEILLANTE
                DE VOS DONNÉES PERSONNELLES PAR UN TIERS ET/OU UN LOGICIEL MALVEILLANT.
            </p>

            <h4>
                7. Qui sont les personnes qui ont accès à vos renseignements personnels et à qui ces
                renseignements sont-ils communiqués ?
            </h4>
            <p>
                Outre les informations que vous partagez sur nos Produits ou que vous communiquez à
                d’autres utilisateurs, nous sommes les seules personnes ayant accès à vos
                renseignements personnels. Cependant, certains renseignements personnels peuvent
                être partagées avec nos partenaires ou fournisseurs lorsque votre utilisation des
                Produits le requiert.
            </p>

            <h4>8. Combien de temps conservons-nous vos renseignements personnels ?</h4>
            <p>
                Nous limitons la conservation de vos renseignements personnels à une durée maximale
                de trois (3) ans suivant votre utilisation d’un de nos Produits ou la fermeture de
                votre compte, selon la date la plus récente.
            </p>

            <h4>
                9. Est-il possible de limiter la collecte de vos renseignements personnels lorsque
                vous utilisez nos Produits?
            </h4>
            <p>
                Oui. Vous pouvez limiter la collecte de vos renseignements personnels en tout temps
                en installant le
                <a href="https://tools.google.com/dlpage/gaoptout/"
                    >Module complémentaire de navigateur pour la désactivation de Google
                    Analytics</a
                >. Plusieurs autres moyens pour empêcher ou limiter la collecte de vos
                renseignements personnels sont également disponibles sur la page de la
                <a href="https://support.google.com/analytics/answer/6004245?hl=fr"
                    >Protection de vos données</a
                >
                de Google, sous l’onglet « Paramètres de confidentialité ».
            </p>
            <p>
                Plus encore, vous pouvez limiter la collecte de vos renseignements personnels en
                <a href="www.allaboutcookies.org/fr/gerer-les-cookies/"
                    >désactivant les fichiers témoins de votre navigateur</a
                >
                et en refusant des demandes d’autorisation lorsque vous naviguez sur nos Produits,
                dont votre emplacement géographique.
            </p>

            <h4>
                10. Comment pouvez-vous formuler une demande pour connaître, mettre à jour, modifier
                ou supprimer vos renseignements personnels ?
            </h4>
            <p>
                La protection de vos renseignements personnels est une préoccupation majeure pour
                nous. Ce faisant, nous mettons à votre disposition de nombreux moyens pour accéder,
                corriger ou supprimer vos renseignements personnels avec célérité notamment par la
                page de votre profil d’utilisateur.
            </p>
            <p>
                Il vous appartient également de communiquer avec notre agent responsable à la
                protection des renseignements personnels dans le but de mettre à jour ou supprimer
                vos renseignements.
            </p>
            <p>
                Pour toute demande additionnelle en pareille matière, nous vous invitons à
                communiquer directement avec notre agent responsable de la protection des
                renseignements personnels au moyen des coordonnées figurant au bas de cette page.
            </p>

            <h4>
                11. Comment effectuer une demande de modification relative à votre consentement pour
                le traitement de vos renseignements personnels ?
            </h4>
            <p>
                Il vous est possible de retirer votre consentement relatif à la collecte, à
                l’utilisation et à la communication de vos renseignements personnels à tout moment
                sous réserve de restrictions prévues par une loi, d’une stipulation externe à la
                présente Politique et d’un préavis de dix (10) jours ouvrables pour traiter votre
                demande.
            </p>
            <p>
                La demande de modification devra être faite par courriel à l’agent dont les
                coordonnées figurent au bas de cette page. Nous accuserons réception de votre
                demande par courriel. Nous pourrons vous demander de nous confirmer votre identité
                avant de vous fournir cette information. En principe, l'accès à cette information
                sera fourni gratuitement, mais, si vous nous demandez une copie ou une transmission
                de votre information, nous pourrions exiger des frais raisonnables. Nous vous
                informerons du montant à l'avance et vous donnerons la possibilité de retirer votre
                demande. Nous donnerons accès aux utilisateurs à leur information dans les dix (10)
                jours suivant la réception de leur demande ou nous leur fournirons un avis par
                courriel pour les aviser qu'un délai supplémentaire est nécessaire pour répondre à
                leur demande.
            </p>
            <p>
                Dans certains cas, nous pourrions être incapables de donner accès à l’information
                concernant vous concernant, en totalité ou en partie. Si nous en sommes incapables
                ou si la loi ne nous le permet pas, nous vous fournirons une explication et
                indiquerons les autres mesures qui sont à votre disposition.
            </p>

            <h4>
                12. Comment pouvez-vous porter plainte à l’égard du non-respect des principes de la
                Politique ?
            </h4>
            <p>
                Pour tout autre commentaire ou pour déposer une plainte relativement à la protection
                de vos renseignements personnels, nous vous invitons à communiquer directement avec
                notre agent responsable de la protection des renseignements personnels au moyen des
                coordonnées figurant au bas de cette page.
            </p>

            <h4>13. Mise à jour de cette Politique de confidentialité sans préavis</h4>
            <p>
                Cette Politique est dynamique et est sujette à changements sans préavis. Vous ne
                pouvez supposer qu'elle restera la même et vous acceptez de vérifier la politique
                chaque fois que vous visitez un ou plusieurs Produits pour y constater les
                changements. Votre utilisation continue des Produits témoigne de votre acceptation
                des dispositions de cette Politique et de toute modification.
            </p>
            <p>
                Dans le cadre de modifications apportées à notre Politique, nous nous engageons à
                utiliser vos renseignements personnels uniquement aux termes et dans le but de la
                présente Politique de confidentialité en vigueur au moment où vous nous avez fourni
                vos renseignements ou comme l'exige ou le permet par ailleurs la loi, sauf si vous
                avez expressément consenti à ce que l'on fasse autrement.
            </p>

            <h4>14. Est-il possible que la politique ne soit pas suivie?</h4>
            <p>
                Lorsque la loi le permet, et même l’oblige, il est possible que nous collections,
                utilisions ou communiquions, en partie ou en totalité, vos renseignements personnels
                à votre insu ou sans votre consentement. Dans une telle hypothèse, nous nous
                assurons que la collecte, l’utilisation et la communication est conforme à la loi et
                veillons à obtenir de rigoureux avis juridiques à cet effet. Nous nous réservons le
                droit de contester ou de faire suite à toute demande relative à la collecte, à
                l’utilisation ou à la communication de tels renseignements personnels.
            </p>

            <h4>15. Disparité et interprétation</h4>
            <p>
                En cas de disparité entre la version française et la version anglaise de cette
                Politique, la version française prévaut sur toute autre version. La présente
                Politique est régie par les Conditions d’utilisation du Site dans le cas où un
                litige ou une incohérence relative à ladite Politique surviendrait.
            </p>

            <h4>
                16. Nom et coordonnées de l’agent(e) responsable de la protection des renseignements
                personnels
            </h4>
            <p>
                Pour toute demande d’accès, de correction, ou de suppression de vos renseignements
                personnels, de même que pour tout commentaire, question ou plainte en cette matière,
                nous vous invitons à contacter Oliver Tétrault, Président et agent(e) responsable de
                la protection des renseignements personnels, par téléphone au 514-923-6548 par
                courriel à l'adresse (438) 794-3432 ou par la poste au 4965, rue Ambroise-Lafortune,
                suite 200, Boisbriand, Quebec J7H 0A4.
            </p>
            <h4>
                17. Limites supplémentaires sur l'utilisation de vos données d'utilisateur Google
            </h4>
            <p>
                Par dérogation à toute disposition à la présente Politique sur la confidentialité,
                si vous autorisez l'Application à accéder aux types suivants de vos données Google;
                l'utilisation que fera l'Application de ces données sera soumise aux limites
                supplémentaires suivantes :
            </p>
            <ul>
                <li>
                    L'Application utilisera l'accès aux données uniquement aux fins de lecture,
                    d'écriture, de modification ou de contrôle du corps des messages Gmail (incluant
                    les pièces jointes), les métadonnées, les en-têtes et les paramétrages pour
                    offrir un client de messagerie Web permettant aux utilisateurs de rédiger,
                    d'envoyer, de lire et de traiter les courriels et ne transférera pas ces données
                    Gmail à d'autres personnes à moins que ce ne soit nécessaire pour offrir et
                    améliorer ces options, se conformer aux lois applicables ou dans le cadre d'une
                    fusion, d'une acquisition ou d'une vente de biens.
                </li>
                <li>L'Application n'utilisera pas ces données Gmail à des fins publicitaires.</li>
                <li>
                    L'Application n'autorisera pas les humains à lire ces données sauf accord
                    affirmatif de votre part quant à l'utilisation de messages spécifiques et
                    lorsqu'une telle utilisation s'avère nécessaire pour des raisons de sécurité
                    comme des enquêtes sur des abus, des questions de conformité aux lois
                    applicables ou pour les opérations internes de l'Application et dans un tel cas,
                    uniquement lorsque les données ont été regroupées et rendues anonymes.
                </li>
            </ul>
        </div>
    </div>
</template>
